import { ethers } from "ethers";


export function hideAccount(value,s=4,e=4) {
  if (value && value.length > 8) {
    return `${value.substring(0, s)}...${
      value.length % s ? "" : ""
    }${value.slice(-e)}`;
  }
  return value;
}

export function calculateDiffTime(start_time) {
  if (!parseInt(start_time)) return "-";
  var endTime = Math.round(new Date() / 1000);

  var timeDiff = endTime - start_time;
  // var day = parseInt(timeDiff / 86400);
  // var hour = parseInt((timeDiff % 86400) / 3600);
  var minute = parseInt((timeDiff % 3600) / 60);

  // day = day ? (day + '天') : '';
  // hour = hour ? (hour + "时") : '';
  minute = minute ? minute : 0;
  return minute;
}

export function getFix2(num) {
  var value = Math.floor(num * 1000) / 1000;
  return value;
}

//装备和属性卡购买价格,以及RT余额需要换算后显示
//使用token的精度进行换算bignum/(10^精度),RT token精度为18
export function big2num(bignumber) {
  //不是bignumber，返回原值
  if (!bignumber._isBigNumber) return bignumber;
  // return bignumber.div(BigNumber.from(10).pow(18)).toNumber()
  return ethers.utils.formatEther(bignumber);
}

export function displayNum(num) {
  if (typeof num == "string") num = parseFloat(num);

  if (typeof num == "number") {
    if (!num) return 0;
    if (num < 0.01) return "< 0.01";
    return num.toFixed(2);
  }
}

export function getDay(date, day) {
  var today = new Date(date);
  var targetday_milliseconds = date + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + "-" + tMonth + "-" + tDate;
  // return today.toLocaleString()
}
export function doHandleMonth(month) {
  var m = month;
  if (month.toString().length == 1) {
    m = "0" + month;
  }
  return m;
}

export function date2block(date) {
  return Math.trunc((new Date(date).getTime() / 1000 + 28800) / 86400);
}

export function block2date(block) {
  let date = new Date((block * 86400 - 28800) * 1000);
  let month = date.getMonth() + 1;
  month = month > 9 ? month : "0" + month;
  let day = date.getDate();
  day = day > 9 ? day : "0" + day;
  return date.getFullYear() + "-" + month + "-" + day;
}

export function fmoney(s, n) {
  if( Math.abs(s) && Math.abs(s) < 0.01) {
    return '< 0.01'
  }
  n = n >= 0 && n <= 20 ? n : 2;
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
  var l = s.split(".")[0].split("").reverse(),
    r = s.split(".")[1];
  let t = "";
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
  }
  let f = t.split("").reverse().join("");
  if (f.startsWith("-,")) {
    f = f.replace("-,", "-");
  }
  
  return f + ((n&& Number(r)) ? "." + r : "");
}

export function handlerWalletTxError(error, intl) {
  const reject_transaction_text = intl.formatMessage({
    id: "common.reject_transaction",
    defaultMessage: "拒絕交易",
  });
  const gas_fee_not_enough = intl.formatMessage({
    id: "common.gas_fee_not_enough",
    defaultMessage: "gas fee不足，请充值",
  });
  console.error(error)
  const { code, reason, message } = error;
  switch (code) {
    case "ACTION_REJECTED":
      return reject_transaction_text;
      break;
    case "401":
      return reject_transaction_text;
      break;
    case "c_1001":
      return gas_fee_not_enough;
      break;
    default:
      return reason || message || code || '';
      break;
  }
}
